import { EMedicalCategoryType } from '@/entities/medical-category';
import { ROUTES } from '@/types/common';

const DIET_TREATMENT_ID = '12';
const MEDICINE_UNIT_ID = 185;
const DEFAULT_REGION_CODE = 11;

export const getCategoryPath = (categoryId: string, categoryType: EMedicalCategoryType): string => {
  if (categoryType === EMedicalCategoryType.TREATMENT && categoryId === DIET_TREATMENT_ID) {
    return `${ROUTES.NON_BENEFIT.HOME.path}?treatmentId=${categoryId}&treatmentMedicineUnitId=${MEDICINE_UNIT_ID}&regionCode=${DEFAULT_REGION_CODE}`;
  }

  return `${ROUTES.TELEMEDICINE.REQUEST.path}?categoryId=${categoryId}&type=${categoryType}`;
};
